import NoteBaseModel from './base-modeles/note-base-model';
import ShapeModel from './shape-model';
// lodash部分引入
import _has from 'lodash/has';
import _set from 'lodash/set';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import ElementBaseConvert from './convert/elementBaseConvert';
import i18n from '@i18next/i18n';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { NotePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/page/note-property-converter';

class NoteModel extends NoteBaseModel implements INoteModel {
    static async convertDataSdkToUi(sdkData, uiData, rawSdkData) {
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData);

        NotePropertyConverter.convertPartialDataFromSdkToUi(sdkData.props, uiData);

        ElementBaseConvert.convertDataSdkToUi(sdkData, uiData, undefined);
        const needBind = sdkData.note;
        const noteData = sdkData.note;
        if (needBind) {
            uiData.noteTextBody.unbindSDK();
            uiData.noteTextBody.bindSDK(noteData);
        }
        // 其余情况下shapemodel内部的绑定会触发更新
    }

    static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        super.convertDataUiToSdk(uiData, sdkData, rawUiData);

        if (_has(uiData, 'noteTextBody.paragraphList')) {
            const sdk = {};
            ShapePropertyConverter.convertPartialDataFromUiToSdk(uiData.noteTextBody, sdk, rawUiData);
            _set(sdkData, 'note', sdk);
        }
    }

    public noteTextBody: any;

    initData = () => {
        if (this.noteTextBody) {
            this.noteTextBody.unbindSDK();
            this.noteTextBody.initParagraphList();
        } else {
            const ui = new ShapeModel();
            ui.initParagraphList();
            ui.parent = this;
            this.noteTextBody = ui;
        }
    };
}


export default NoteModel;
